// Default session pages configuration
// Will be replaced by backend data when APIs are implemented
export const defaultSessionPages = [
  { id: 1, key: "overview", order: 1 },
  { id: 2, key: "highlights", order: 2 },
  { id: 3, key: "by_dimension", order: 3 },
  { id: 4, key: "top_customers", order: 4 },
  { id: 5, key: "top_products", order: 5 },
  { id: 6, key: "initiatives", order: 6 },
];

// Transition duration for page changes (ms)
export const TRANSITION_DURATION = 150;

// Mock P&L Structure - Food Brands (estrutura real do backend)
// Level 1: Main lines (totals)
// Level 2: First level deductions
// Level 3: Detail breakdown (children)
// prettier-ignore
export const mockPlStructure = [
  // Volume
  { meta_name: "volume", name: "Volume", level: 0, is_parent: false, parent: null },

  // Receita Bruta
  { meta_name: "gross_revenue", name: "Receita Bruta", level: 1, is_parent: false, parent: null },

  // Deduções da Receita Bruta
  { meta_name: "taxes", name: "Impostos", level: 2, is_parent: true, parent: null },
  { meta_name: "taxes_icms", name: "ICMS", level: 3, is_parent: false, parent: "taxes" },
  { meta_name: "taxes_pis", name: "PIS", level: 3, is_parent: false, parent: "taxes" },
  { meta_name: "taxes_cofins", name: "COFINS", level: 3, is_parent: false, parent: "taxes" },
  { meta_name: "taxes_icms_st", name: "ICMS-ST", level: 3, is_parent: false, parent: "taxes" },

  { meta_name: "financial_discounts", name: "Descontos Financeiros", level: 2, is_parent: true, parent: null },
  { meta_name: "financial_discounts_comml_agreement", name: "Acordo Comercial", level: 3, is_parent: false, parent: "financial_discounts" },
  { meta_name: "financial_discounts_spot_agreement", name: "Acordo Spot", level: 3, is_parent: false, parent: "financial_discounts" },

  { meta_name: "cancellations_and_returns", name: "Devoluções e Cancelamentos", level: 2, is_parent: false, parent: null },

  { meta_name: "bonifications", name: "Bonificações", level: 2, is_parent: true, parent: null },
  { meta_name: "bonifications_granted", name: "Bonificação Concedida", level: 3, is_parent: false, parent: "bonifications" },
  { meta_name: "bonifications_cash", name: "Bonificação em Dinheiro", level: 3, is_parent: false, parent: "bonifications" },

  // Receita Líquida
  { meta_name: "net_revenue", name: "Receita Líquida", level: 1, is_parent: false, parent: null },

  // CMV / COGS
  { meta_name: "cogs", name: "CMV", level: 2, is_parent: true, parent: null },
  { meta_name: "cogs_product_costs", name: "Custo do Produto", level: 3, is_parent: false, parent: "cogs" },
  { meta_name: "cogs_inbound_freights", name: "Fretes de Entrada", level: 3, is_parent: false, parent: "cogs" },
  { meta_name: "cogs_payroll", name: "Pessoal Produção", level: 3, is_parent: false, parent: "cogs" },
  { meta_name: "cogs_rental_costs", name: "Aluguéis", level: 3, is_parent: false, parent: "cogs" },
  { meta_name: "cogs_d_and_a", name: "D&A Produção", level: 3, is_parent: false, parent: "cogs" },
  { meta_name: "cogs_tax_credits", name: "Créditos Fiscais", level: 3, is_parent: false, parent: "cogs" },
  { meta_name: "cogs_general_costs", name: "Custos Gerais", level: 3, is_parent: false, parent: "cogs" },

  // Lucro Bruto
  { meta_name: "gross_profit", name: "Lucro Bruto", level: 1, is_parent: false, parent: null },

  // Deduções do Lucro Bruto
  { meta_name: "royalties", name: "Royalties", level: 2, is_parent: false, parent: null },

  { meta_name: "sales_expenses", name: "Despesas Comerciais", level: 2, is_parent: true, parent: null },
  { meta_name: "sales_exp_comissions", name: "Comissões", level: 3, is_parent: false, parent: "sales_expenses" },
  { meta_name: "sales_exp_payroll", name: "Pessoal Vendas", level: 3, is_parent: false, parent: "sales_expenses" },
  { meta_name: "sales_exp_others", name: "Outras Despesas Vendas", level: 3, is_parent: false, parent: "sales_expenses" },

  { meta_name: "trade_marketing", name: "Trade Marketing", level: 2, is_parent: true, parent: null },
  { meta_name: "trade_marketing_payroll", name: "Pessoal Trade", level: 3, is_parent: false, parent: "trade_marketing" },
  { meta_name: "trade_marketing_others", name: "Outras Trade", level: 3, is_parent: false, parent: "trade_marketing" },
  { meta_name: "merchandising_third_party", name: "Merchandising Terceiros", level: 3, is_parent: false, parent: "trade_marketing" },

  { meta_name: "logistics", name: "Logística", level: 2, is_parent: true, parent: null },
  { meta_name: "warehousing", name: "Armazenagem", level: 3, is_parent: false, parent: "logistics" },
  { meta_name: "outbound_freights", name: "Fretes de Saída", level: 3, is_parent: false, parent: "logistics" },

  // Margem de Servir
  { meta_name: "serve_margin", name: "Margem de Servir", level: 1, is_parent: false, parent: null },
];

// Mock P&L Values - Food Brands (formato real - plValues[numPL][meta_name])
// Based on real BigQuery data structure
// Values in BRL (Brazilian Real)
// YTD 2024 (numPL 1) vs YTD 2025 (numPL 2)
export const mockPlValues = {
  // YTD 2024
  1: {
    // Volume (kg)
    volume: 25049000,

    // Receita Bruta
    gross_revenue: 217145000,

    // Deduções - Impostos
    taxes: -32571750,
    taxes_icms: -19543050,
    taxes_pis: -3692565,
    taxes_cofins: -6960735,
    taxes_icms_st: -2375400,

    // Deduções - Descontos Financeiros
    financial_discounts: -10857250,
    financial_discounts_comml_agreement: -7600075,
    financial_discounts_spot_agreement: -3257175,

    // Devoluções e Cancelamentos
    cancellations_and_returns: -4342900,

    // Bonificações
    bonifications: -6514350,
    bonifications_granted: -4560045,
    bonifications_cash: -1954305,

    // Receita Líquida (RB - Impostos - Descontos - Devoluções - Bonificações)
    net_revenue: 162858750,

    // CMV / COGS
    cogs: -113001075,
    cogs_product_costs: -84715313,
    cogs_inbound_freights: -6509088,
    cogs_payroll: -8140941,
    cogs_rental_costs: -4886352,
    cogs_d_and_a: -3255688,
    cogs_tax_credits: 4886352,
    cogs_general_costs: -10380045,

    // Lucro Bruto (RL - CMV)
    gross_profit: 49857675,

    // Royalties
    royalties: -3257175,

    // Despesas Comerciais
    sales_expenses: -8143438,
    sales_exp_comissions: -4886063,
    sales_exp_payroll: -2443031,
    sales_exp_others: -814344,

    // Trade Marketing
    trade_marketing: -6514350,
    trade_marketing_payroll: -3257175,
    trade_marketing_others: -1628588,
    merchandising_third_party: -1628587,

    // Logística
    logistics: -9771525,
    warehousing: -4071463,
    outbound_freights: -5700062,

    // Margem de Servir (LB - Royalties - Desp.Comerciais - Trade - Logística)
    serve_margin: 22171187,
  },

  // YTD 2025
  2: {
    // Volume (kg)
    volume: 26500000,

    // Receita Bruta
    gross_revenue: 236840000,

    // Deduções - Impostos
    taxes: -35526000,
    taxes_icms: -21315600,
    taxes_pis: -4026280,
    taxes_cofins: -7578120,
    taxes_icms_st: -2606000,

    // Deduções - Descontos Financeiros
    financial_discounts: -11842000,
    financial_discounts_comml_agreement: -8289400,
    financial_discounts_spot_agreement: -3552600,

    // Devoluções e Cancelamentos
    cancellations_and_returns: -4736800,

    // Bonificações
    bonifications: -7105200,
    bonifications_granted: -4973640,
    bonifications_cash: -2131560,

    // Receita Líquida
    net_revenue: 177630000,

    // CMV / COGS
    cogs: -123196500,
    cogs_product_costs: -92397375,
    cogs_inbound_freights: -7099260,
    cogs_payroll: -8876325,
    cogs_rental_costs: -5328195,
    cogs_d_and_a: -3549930,
    cogs_tax_credits: 5328195,
    cogs_general_costs: -11273610,

    // Lucro Bruto
    gross_profit: 54433500,

    // Royalties
    royalties: -3552600,

    // Despesas Comerciais
    sales_expenses: -8881500,
    sales_exp_comissions: -5328900,
    sales_exp_payroll: -2664450,
    sales_exp_others: -888150,

    // Trade Marketing
    trade_marketing: -7105200,
    trade_marketing_payroll: -3552600,
    trade_marketing_others: -1776300,
    merchandising_third_party: -1776300,

    // Logística
    logistics: -10658100,
    warehousing: -4440875,
    outbound_freights: -6217225,

    // Margem de Servir
    serve_margin: 24236100,
  },
};

// P&L Anchors - Food Brands
export const PL_ANCHORS = {
  netRevenue: "net_revenue",
  serveMargin: "serve_margin",
  grossProfit: "gross_profit",
  revenueAnchors: ["gross_revenue", "net_revenue"],
  marginAnchors: ["gross_profit", "serve_margin"],
  volumeUnit: "kg",
  currencyUnit: "R$",
};

// Mock Heatmap data - Real BigQuery Data (margem de servir % sobre receita bruta)
// Data only available from 2024 onwards, December 2025 not yet available
// 2022 and 2023 have no data (all null) to show the visual representation
export const mockHeatmapData = {
  years: [2022, 2023, 2024, 2025],
  months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  values: {
    // prettier-ignore
    2022: [null, null, null, null, null, null, null, null, null, null, null, null],
    // prettier-ignore
    2023: [null, null, null, null, null, null, null, null, null, null, null, null],
    // prettier-ignore
    2024: [11.5, 11.1, 13.3, 15.2, 15.3, 13.6, 12.9, 11.5, 11.4, 11.9, 13.3, 10.3],
    // prettier-ignore
    2025: [10.4, 13.1, 14.3, 11.0, 15.2, 13.1, 10.7, 11.3, 41.1, 12.5, 18.0, null],
  },
};

// Mock messages data - Food Brands (will be replaced by backend data)
export const mockMessages = [
  {
    title: "Resultado do período",
    text: "YTD 2025 apresenta crescimento de receita líquida de +9.1% vs YTD 2024, com margem de servir estável em 13.6%. Volume cresceu +5.8% impulsionado principalmente por Cash & Carry.",
  },
  {
    title: "Destaque positivo",
    text: "Categoria Pipoca apresentou crescimento expressivo (+25% em volume) devido a campanhas sazonais bem executadas. Cliente ASSAI SP contribuiu com +R$ 1.8MM de margem adicional.",
  },
  {
    title: "Ponto de atenção",
    text: "Categoria Molhos Billy & Jack apresenta queda de -37% em volume. Recomenda-se revisão da política de preços e análise de ruptura de estoque no período.",
  },
];

// Real data from BigQuery - Food Brands monthly data
// Current year: 2025 (Jan-Nov available, Dec not yet available)
// Previous year: 2024 (full year)
// Volume in thousands (tons), Revenue in millions (R$)
export const mockChartData12Months = [
  {
    month: "Jan",
    volumeCurrent: 2505,
    volumePrevious: 2407,
    revenueCurrent: 34.37,
    revenuePrevious: 32.7,
  },
  {
    month: "Fev",
    volumeCurrent: 3204,
    volumePrevious: 2825,
    revenueCurrent: 43.52,
    revenuePrevious: 35.13,
  },
  {
    month: "Mar",
    volumeCurrent: 3502,
    volumePrevious: 3404,
    revenueCurrent: 47.03,
    revenuePrevious: 43.25,
  },
  {
    month: "Abr",
    volumeCurrent: 3393,
    volumePrevious: 3362,
    revenueCurrent: 42.78,
    revenuePrevious: 43.8,
  },
  {
    month: "Mai",
    volumeCurrent: 4776,
    volumePrevious: 4150,
    revenueCurrent: 59.69,
    revenuePrevious: 55.35,
  },
  {
    month: "Jun",
    volumeCurrent: 4182,
    volumePrevious: 4260,
    revenueCurrent: 53.49,
    revenuePrevious: 53.17,
  },
  {
    month: "Jul",
    volumeCurrent: 3487,
    volumePrevious: 3532,
    revenueCurrent: 47.25,
    revenuePrevious: 46.87,
  },
  {
    month: "Ago",
    volumeCurrent: 3593,
    volumePrevious: 3315,
    revenueCurrent: 47.16,
    revenuePrevious: 44.01,
  },
  {
    month: "Set",
    volumeCurrent: 3375,
    volumePrevious: 2868,
    revenueCurrent: 45.53,
    revenuePrevious: 38.19,
  },
  {
    month: "Out",
    volumeCurrent: 3403,
    volumePrevious: 3282,
    revenueCurrent: 44.63,
    revenuePrevious: 43.25,
  },
  {
    month: "Nov",
    volumeCurrent: 4938,
    volumePrevious: 3699,
    revenueCurrent: 67.06,
    revenuePrevious: 46.92,
  },
  // December 2025 not yet available - null values to show gap in chart
  {
    month: "Dez",
    volumeCurrent: null,
    volumePrevious: 3766,
    revenueCurrent: null,
    revenuePrevious: 46.42,
  },
];

// Mock Indicators - Food Brands (5 indicadores)
// Based on YTD 2025 vs YTD 2024 comparison
// prettier-ignore
export const mockIndicators = [
  { label: "Δ Volume", value: "+5.8%", subtext: "+1.45 MM kg", positive: true },
  { label: "Δ Preço Bruto", value: "+3.4%", subtext: "R$ 8.67 → R$ 8.94/kg", positive: true },
  { label: "Δ Receita Líquida", value: "+9.1%", subtext: "+R$ 14.8 MM", positive: true },
  { label: "Δ Margem de Servir", value: "+R$ 2.1 MM", subtext: "13.6% → 13.6%", positive: true },
  { label: "Δ % Margem de Servir", value: "+0.0 pp", subtext: "s/ Receita Líquida", positive: true },
];

// Mock Drivers - Losses (Food Brands)
// Based on real client and product analysis
// prettier-ignore
export const mockDriversLosses = [
  { element: "ATACADAO SP", dimension: "Cliente", narrative: "queda de volume de -8.0% e preço médio -12.0% (maior desconto negociado)", impact: -1021, relevance: "high" },
  { element: "MOLHO ORIG BILLY JACK 6X1,01KG", dimension: "Produto", narrative: "queda de volume de -36.8% por ruptura de estoque no 1º trimestre", impact: -2217, relevance: "high" },
  { element: "MUFFATO", dimension: "Cliente", narrative: "redução de volume -19.5% e preço -30.9% (promoções agressivas)", impact: -515, relevance: "medium" },
  { element: "FAROFA PRONTA 24X400GRS", dimension: "Produto", narrative: "queda de volume -40.0% por aumento de concorrência (marca própria)", impact: -581, relevance: "medium" },
];

// Mock Drivers - Gains (Food Brands)
// Based on real client and product analysis
// prettier-ignore
export const mockDriversGains = [
  { element: "ASSAI SP", dimension: "Cliente", narrative: "crescimento de volume +4.3% e preço +5.7% (melhor posicionamento)", impact: 1824, relevance: "high" },
  { element: "MILHO PIPOCA PREMIUM 24X400GRS", dimension: "Produto", narrative: "crescimento de volume +19.4% por campanha de verão bem-sucedida", impact: 848, relevance: "high" },
  { element: "ROLDAO", dimension: "Cliente", narrative: "crescimento de volume +66.7% por expansão de lojas (6 novas)", impact: 734, relevance: "medium" },
  { element: "MILHO PIPOCA 24X400GRS", dimension: "Produto", narrative: "crescimento de volume +30.0% impulsionado por festas juninas", impact: 595, relevance: "medium" },
];

// Function to generate mock dimension data with translations
// This will be replaced by real API data in the future
// share = current period representation (%), sharePrevious = previous period representation (%)
export const getMockDimensionData = (t) => ({
  total: {
    name: t("alignment_session.by_dimension.total_company"),
    // Real data from BigQuery: Food Brands Jan-Nov 2024 vs 2025
    elements: [
      {
        name: "Total Companhia",
        share: 100.0,
        sharePrevious: 100.0,
        deltaVolume: 8.8,
        deltaAvgPrice: 0.0,
        deltaRevenue: 8.8,
        deltaMargin: 21009,
        deltaMarginPct: 4.4,
      },
    ],
  },
  channel: {
    name: t("alignment_session.by_dimension.dimensions.channel"),
    elements: [
      // prettier-ignore
      { name: "Varejo", share: 32.1, sharePrevious: 30.5, deltaVolume: 7.3, deltaAvgPrice: 4.5, deltaRevenue: 12.1, deltaMargin: 520, deltaMarginPct: 1.2 },
      // prettier-ignore
      { name: "Atacado", share: 25.8, sharePrevious: 26.8, deltaVolume: 3.1, deltaAvgPrice: 2.2, deltaRevenue: 5.4, deltaMargin: 280, deltaMarginPct: -0.3 },
      // prettier-ignore
      { name: "Food Service", share: 14.2, sharePrevious: 15.4, deltaVolume: -2.4, deltaAvgPrice: 3.7, deltaRevenue: 1.2, deltaMargin: 95, deltaMarginPct: 0.8 },
      // prettier-ignore
      { name: "E-commerce", share: 10.5, sharePrevious: 8.2, deltaVolume: 15.6, deltaAvgPrice: 2.3, deltaRevenue: 18.3, deltaMargin: 64, deltaMarginPct: 2.1 },
      // prettier-ignore
      { name: "Ind. Transf.", share: 6.8, sharePrevious: 7.8, deltaVolume: -5.2, deltaAvgPrice: 1.5, deltaRevenue: -3.8, deltaMargin: -42, deltaMarginPct: -1.5 },
      // prettier-ignore
      { name: "Exportação", share: 4.9, sharePrevious: 4.5, deltaVolume: 8.9, deltaAvgPrice: 2.1, deltaRevenue: 11.2, deltaMargin: 42, deltaMarginPct: 0.4 },
      // prettier-ignore
      { name: "Institucional", share: 3.5, sharePrevious: 3.8, deltaVolume: 2.8, deltaAvgPrice: 1.7, deltaRevenue: 4.5, deltaMargin: 18, deltaMarginPct: 0.2 },
      // prettier-ignore
      { name: "Outros", share: 2.2, sharePrevious: 3.0, deltaVolume: -1.5, deltaAvgPrice: 2.3, deltaRevenue: 0.8, deltaMargin: -12, deltaMarginPct: -0.4 },
    ],
  },
  category: {
    name: t("alignment_session.by_dimension.dimensions.category"),
    // Real data from BigQuery: Food Brands Jan-Nov 2024 vs 2025
    elements: [
      // prettier-ignore
      { name: "Farináceos", share: 18.9, sharePrevious: 16.9, deltaVolume: 19.1, deltaAvgPrice: 1.8, deltaRevenue: 21.2, deltaMargin: 6608, deltaMarginPct: 5.9 },
      // prettier-ignore
      { name: "Molhos", share: 17.7, sharePrevious: 20.2, deltaVolume: -12.8, deltaAvgPrice: 9.5, deltaRevenue: -4.5, deltaMargin: 724, deltaMarginPct: 2.3 },
      // prettier-ignore
      { name: "Especiarias", share: 15.4, sharePrevious: 15.0, deltaVolume: 2.6, deltaAvgPrice: 8.5, deltaRevenue: 11.3, deltaMargin: 2457, deltaMarginPct: 0.9 },
      // prettier-ignore
      { name: "Pipoca", share: 10.3, sharePrevious: 9.4, deltaVolume: 34.2, deltaAvgPrice: -11.0, deltaRevenue: 19.4, deltaMargin: 4967, deltaMarginPct: 12.4 },
      // prettier-ignore
      { name: "Farofa", share: 7.8, sharePrevious: 8.6, deltaVolume: -6.2, deltaAvgPrice: 4.7, deltaRevenue: -1.8, deltaMargin: 1560, deltaMarginPct: 5.9 },
      // prettier-ignore
      { name: "Cond. Industrializados", share: 6.3, sharePrevious: 6.4, deltaVolume: -3.9, deltaAvgPrice: 10.4, deltaRevenue: 6.1, deltaMargin: 132, deltaMarginPct: -0.4 },
      // prettier-ignore
      { name: "Batata Palha", share: 5.1, sharePrevious: 5.5, deltaVolume: -1.4, deltaAvgPrice: 2.2, deltaRevenue: 0.8, deltaMargin: 1260, deltaMarginPct: 7.0 },
      // prettier-ignore
      { name: "Grãos", share: 4.0, sharePrevious: 3.4, deltaVolume: 20.3, deltaAvgPrice: 8.2, deltaRevenue: 30.1, deltaMargin: 1696, deltaMarginPct: 13.4 },
      // prettier-ignore
      { name: "Outros", share: 14.5, sharePrevious: 14.6, deltaVolume: 7.5, deltaAvgPrice: 0.7, deltaRevenue: 8.2, deltaMargin: 1605, deltaMarginPct: 1.5 },
    ],
  },
  region: {
    name: t("alignment_session.by_dimension.dimensions.region"),
    elements: [
      // prettier-ignore
      { name: "Sudeste", share: 38.5, sharePrevious: 37.8, deltaVolume: 6.2, deltaAvgPrice: 3.0, deltaRevenue: 9.4, deltaMargin: 450, deltaMarginPct: 0.4 },
      // prettier-ignore
      { name: "Sul", share: 20.2, sharePrevious: 20.5, deltaVolume: 4.8, deltaAvgPrice: 2.3, deltaRevenue: 7.2, deltaMargin: 280, deltaMarginPct: 0.8 },
      // prettier-ignore
      { name: "Nordeste", share: 16.8, sharePrevious: 17.2, deltaVolume: 3.1, deltaAvgPrice: 3.3, deltaRevenue: 6.5, deltaMargin: 150, deltaMarginPct: -0.5 },
      // prettier-ignore
      { name: "Centro-Oeste", share: 10.5, sharePrevious: 9.8, deltaVolume: 7.5, deltaAvgPrice: 3.5, deltaRevenue: 11.3, deltaMargin: 79, deltaMarginPct: 1.2 },
      // prettier-ignore
      { name: "Norte", share: 6.2, sharePrevious: 6.8, deltaVolume: -2.1, deltaAvgPrice: 4.0, deltaRevenue: 1.8, deltaMargin: -28, deltaMarginPct: -0.9 },
      // prettier-ignore
      { name: "DF", share: 3.8, sharePrevious: 3.5, deltaVolume: 5.2, deltaAvgPrice: 2.8, deltaRevenue: 8.1, deltaMargin: 35, deltaMarginPct: 0.5 },
      // prettier-ignore
      { name: "Interior SP", share: 2.5, sharePrevious: 2.2, deltaVolume: 9.1, deltaAvgPrice: 3.0, deltaRevenue: 12.4, deltaMargin: 48, deltaMarginPct: 1.0 },
      // prettier-ignore
      { name: "Outros", share: 1.5, sharePrevious: 2.2, deltaVolume: 1.2, deltaAvgPrice: 2.2, deltaRevenue: 3.4, deltaMargin: 28, deltaMarginPct: 0.1 },
    ],
  },
  customer: {
    name: t("alignment_session.by_dimension.dimensions.customer"),
    elements: [
      // prettier-ignore
      { name: "Cliente A", share: 22.5, sharePrevious: 20.8, deltaVolume: 12.3, deltaRevenue: 15.8, deltaMargin: 320, deltaMarginPct: 1.5 },
      // prettier-ignore
      { name: "Cliente B", share: 18.2, sharePrevious: 18.5, deltaVolume: 5.4, deltaRevenue: 8.2, deltaMargin: 210, deltaMarginPct: 0.3 },
      // prettier-ignore
      { name: "Cliente C", share: 15.8, sharePrevious: 16.5, deltaVolume: -1.2, deltaRevenue: 3.5, deltaMargin: 150, deltaMarginPct: -0.4 },
      // prettier-ignore
      { name: "Cliente D", share: 13.5, sharePrevious: 12.8, deltaVolume: 8.7, deltaRevenue: 11.4, deltaMargin: 95, deltaMarginPct: 0.9 },
      // prettier-ignore
      { name: "Cliente E", share: 11.2, sharePrevious: 12.5, deltaVolume: -4.5, deltaRevenue: -2.1, deltaMargin: -45, deltaMarginPct: -1.2 },
      // prettier-ignore
      { name: "Cliente F", share: 8.5, sharePrevious: 8.8, deltaVolume: 2.1, deltaRevenue: 5.3, deltaMargin: 29, deltaMarginPct: 0.2 },
      // prettier-ignore
      { name: "Cliente G", share: 6.2, sharePrevious: 5.5, deltaVolume: 6.8, deltaRevenue: 9.5, deltaMargin: 52, deltaMarginPct: 0.7 },
      // prettier-ignore
      { name: "Cliente H", share: 4.1, sharePrevious: 4.6, deltaVolume: -3.2, deltaRevenue: 0.5, deltaMargin: -18, deltaMarginPct: -0.8 },
    ],
  },
  product: {
    name: t("alignment_session.by_dimension.dimensions.product"),
    elements: [
      // prettier-ignore
      { name: "Produto X", share: 25.2, sharePrevious: 24.0, deltaVolume: 9.8, deltaRevenue: 13.2, deltaMargin: 280, deltaMarginPct: 1.1 },
      // prettier-ignore
      { name: "Produto Y", share: 19.5, sharePrevious: 19.8, deltaVolume: 4.5, deltaRevenue: 7.8, deltaMargin: 220, deltaMarginPct: 0.4 },
      // prettier-ignore
      { name: "Produto Z", share: 15.8, sharePrevious: 16.2, deltaVolume: 1.2, deltaRevenue: 4.5, deltaMargin: 180, deltaMarginPct: -0.3 },
      // prettier-ignore
      { name: "Produto W", share: 12.5, sharePrevious: 13.2, deltaVolume: -2.8, deltaRevenue: 0.5, deltaMargin: 95, deltaMarginPct: 0.6 },
      // prettier-ignore
      { name: "Produto V", share: 10.2, sharePrevious: 9.5, deltaVolume: 6.3, deltaRevenue: 9.1, deltaMargin: 64, deltaMarginPct: 0.8 },
      // prettier-ignore
      { name: "Produto U", share: 7.8, sharePrevious: 8.5, deltaVolume: -5.1, deltaRevenue: -3.2, deltaMargin: -38, deltaMarginPct: -1.0 },
      // prettier-ignore
      { name: "Produto T", share: 5.5, sharePrevious: 5.2, deltaVolume: 3.2, deltaRevenue: 5.8, deltaMargin: 32, deltaMarginPct: 0.3 },
      // prettier-ignore
      { name: "Produto S", share: 3.5, sharePrevious: 3.6, deltaVolume: -1.8, deltaRevenue: 1.2, deltaMargin: -15, deltaMarginPct: -0.5 },
    ],
  },
});

// Function to get dimension options with translations
export const getDimensionOptions = (t) => [
  {
    value: "channel",
    label: t("alignment_session.by_dimension.dimensions.channel"),
  },
  {
    value: "category",
    label: t("alignment_session.by_dimension.dimensions.category"),
  },
  {
    value: "region",
    label: t("alignment_session.by_dimension.dimensions.region"),
  },
  {
    value: "customer",
    label: t("alignment_session.by_dimension.dimensions.customer"),
  },
  {
    value: "product",
    label: t("alignment_session.by_dimension.dimensions.product"),
  },
];

// Period comparison options for the Alignment Session.
// Mirrors the same 8 options available on the Trends page.
// Keys match the Trends page values; labels reuse the existing i18n keys
// under `results.trends.*`.
export const PERIOD_DEFAULT = "ytd_vs_ytd";

export const getPeriodOptions = (t) => [
  { key: "ytd_vs_ytd", label: t("results.trends.ytd_vs_ytd") },
  { key: "last_month_vs_ly", label: t("results.trends.last_month_vs_ly") },
  { key: "last_3m_vs_ly", label: t("results.trends.last_3m_vs_ly") },
  { key: "last_6m_vs_ly", label: t("results.trends.last_6m_vs_ly") },
  { key: "last_month_vs_prev", label: t("results.trends.last_month_vs_prev") },
  { key: "last_3m_vs_prev", label: t("results.trends.last_3m_vs_prev") },
  { key: "last_6m_vs_prev", label: t("results.trends.last_6m_vs_prev") },
  { key: "last_12m_vs_prev", label: t("results.trends.last_12m_vs_prev") },
];

// ---------------------------------------------------------------------------
// Period availability helpers
// Pure functions (no hooks) replicating the same logic used in Trends.js to
// determine which comparison period options have enough data.
// ---------------------------------------------------------------------------

function _getPeriodsRange(latestPeriod, numMonths, offset = 0) {
  const periods = [];
  let year = Math.floor(latestPeriod / 100);
  let month = latestPeriod % 100;

  for (let i = 0; i < offset; i++) {
    month--;
    if (month === 0) {
      month = 12;
      year--;
    }
  }

  for (let i = 0; i < numMonths; i++) {
    periods.push(year * 100 + month);
    month--;
    if (month === 0) {
      month = 12;
      year--;
    }
  }

  return periods;
}

function _getYTDPeriods(latestPeriod) {
  const periods = [];
  const year = Math.floor(latestPeriod / 100);
  const lastMonth = latestPeriod % 100;

  for (let m = 1; m <= lastMonth; m++) {
    periods.push(year * 100 + m);
  }

  return periods;
}

/**
 * Convert raw period items from the backend ([year, month] pairs) into a Set
 * of YYYYMM integers for O(1) lookups.
 */
export function convertPeriodsToSet(rawPeriods) {
  if (!rawPeriods || rawPeriods.length === 0) return new Set();
  return new Set(
    rawPeriods.map((p) => (Array.isArray(p) ? p[0] * 100 + p[1] : p)),
  );
}

/**
 * Build the 8 period comparison options with an `isDisabled` flag indicating
 * whether all required months (current + previous sides) exist in the
 * available data.
 *
 * @param {Set<number>} availablePeriodsSet  Set of YYYYMM integers with data
 * @param {number}      refYear              Reference year  (session.year)
 * @param {number}      refMonth             Reference month (session.period_value)
 * @param {Function}    t                    i18next translate function
 * @returns {Array<{key: string, label: string, isDisabled: boolean}>}
 */
export function getAvailablePeriodOptions(
  availablePeriodsSet,
  refYear,
  refMonth,
  t,
) {
  const allDisabled = getPeriodOptions(t).map((opt) => ({
    ...opt,
    isDisabled: true,
  }));

  if (
    !availablePeriodsSet ||
    availablePeriodsSet.size === 0 ||
    !refYear ||
    !refMonth
  ) {
    return allDisabled;
  }

  const refPeriod = refYear * 100 + refMonth;

  const allAvailable = (periods) =>
    periods.every((p) => availablePeriodsSet.has(p));

  // YTD vs YTD
  const currentYTD = _getYTDPeriods(refPeriod);
  const lastYearYTD = _getYTDPeriods((refYear - 1) * 100 + refMonth);
  const ytdOk = allAvailable([...currentYTD, ...lastYearYTD]);

  // Last month vs same month last year
  const lmLyOk = allAvailable([refPeriod, (refYear - 1) * 100 + refMonth]);

  // Last 3m vs same 3m last year
  const l3m = _getPeriodsRange(refPeriod, 3);
  const l3mLy = l3m.map((p) => {
    const y = Math.floor(p / 100);
    const m = p % 100;
    return (y - 1) * 100 + m;
  });
  const l3mLyOk = allAvailable([...l3m, ...l3mLy]);

  // Last 6m vs same 6m last year
  const l6m = _getPeriodsRange(refPeriod, 6);
  const l6mLy = l6m.map((p) => {
    const y = Math.floor(p / 100);
    const m = p % 100;
    return (y - 1) * 100 + m;
  });
  const l6mLyOk = allAvailable([...l6m, ...l6mLy]);

  // Last month vs previous month
  const lmPrevOk = allAvailable(_getPeriodsRange(refPeriod, 2));

  // Last 3m vs previous 3m
  const l3mPrevOk = allAvailable(_getPeriodsRange(refPeriod, 6));

  // Last 6m vs previous 6m
  const l6mPrevOk = allAvailable(_getPeriodsRange(refPeriod, 12));

  // Last 12m vs previous 12m
  const l12mPrevOk = allAvailable(_getPeriodsRange(refPeriod, 24));

  return [
    {
      key: "ytd_vs_ytd",
      label: t("results.trends.ytd_vs_ytd"),
      isDisabled: !ytdOk,
    },
    {
      key: "last_month_vs_ly",
      label: t("results.trends.last_month_vs_ly"),
      isDisabled: !lmLyOk,
    },
    {
      key: "last_3m_vs_ly",
      label: t("results.trends.last_3m_vs_ly"),
      isDisabled: !l3mLyOk,
    },
    {
      key: "last_6m_vs_ly",
      label: t("results.trends.last_6m_vs_ly"),
      isDisabled: !l6mLyOk,
    },
    {
      key: "last_month_vs_prev",
      label: t("results.trends.last_month_vs_prev"),
      isDisabled: !lmPrevOk,
    },
    {
      key: "last_3m_vs_prev",
      label: t("results.trends.last_3m_vs_prev"),
      isDisabled: !l3mPrevOk,
    },
    {
      key: "last_6m_vs_prev",
      label: t("results.trends.last_6m_vs_prev"),
      isDisabled: !l6mPrevOk,
    },
    {
      key: "last_12m_vs_prev",
      label: t("results.trends.last_12m_vs_prev"),
      isDisabled: !l12mPrevOk,
    },
  ];
}

// Real data from BigQuery - Food Brands YTD 2025 vs YTD 2024
export const mockTopClients = [
  {
    id: 1,
    name: "ASSAI SP",
    share: 16.41,
    rankingChange: 0,
    deltaVolume: 4.3,
    deltaAvgPrice: 5.7,
    deltaRevenue: 10.3,
    deltaMargin: 1824211,
    deltaMarginPct: 2.6,
  },
  {
    id: 2,
    name: "ATACADAO SP",
    share: 8.5,
    rankingChange: 0,
    deltaVolume: -8.0,
    deltaAvgPrice: -12.0,
    deltaRevenue: -19.1,
    deltaMargin: -1020908,
    deltaMarginPct: -0.8,
  },
  {
    id: 3,
    name: "VAREJO",
    share: 6.47,
    rankingChange: 0,
    deltaVolume: 7.9,
    deltaAvgPrice: 3.5,
    deltaRevenue: 11.6,
    deltaMargin: 338450,
    deltaMarginPct: 0.2,
  },
  {
    id: 4,
    name: "PEDREIRA",
    share: 3.15,
    rankingChange: 1,
    deltaVolume: 4.0,
    deltaAvgPrice: 2.3,
    deltaRevenue: 6.4,
    deltaMargin: 165378,
    deltaMarginPct: 1.6,
  },
  {
    id: 5,
    name: "NAGUMO",
    share: 2.53,
    rankingChange: 3,
    deltaVolume: 18.0,
    deltaAvgPrice: -0.9,
    deltaRevenue: 16.9,
    deltaMargin: 273093,
    deltaMarginPct: 3.4,
  },
  {
    id: 6,
    name: "SONDA",
    share: 2.22,
    rankingChange: -1,
    deltaVolume: 7.3,
    deltaAvgPrice: -8.2,
    deltaRevenue: -1.4,
    deltaMargin: -24847,
    deltaMarginPct: -0.2,
  },
  {
    id: 7,
    name: "ROLDAO",
    share: 2.22,
    rankingChange: 15,
    deltaVolume: 66.7,
    deltaAvgPrice: 9.9,
    deltaRevenue: 83.2,
    deltaMargin: 734047,
    deltaMarginPct: 9.2,
  },
  {
    id: 8,
    name: "ATACADO",
    share: 2.17,
    rankingChange: 2,
    deltaVolume: 15.0,
    deltaAvgPrice: 5.0,
    deltaRevenue: 20.8,
    deltaMargin: 103651,
    deltaMarginPct: -1.4,
  },
  {
    id: 9,
    name: "DISTRIBUIDOR",
    share: 2.05,
    rankingChange: 1,
    deltaVolume: 29.7,
    deltaAvgPrice: -10.9,
    deltaRevenue: 15.6,
    deltaMargin: 39666,
    deltaMarginPct: -0.9,
  },
  {
    id: 10,
    name: "SHIBATA",
    share: 1.9,
    rankingChange: 1,
    deltaVolume: 18.7,
    deltaAvgPrice: -5.1,
    deltaRevenue: 12.7,
    deltaMargin: -52289,
    deltaMarginPct: -3.1,
  },
  {
    id: 11,
    name: "PAO DE ACUCAR",
    share: 1.85,
    rankingChange: 5,
    deltaVolume: 212.2,
    deltaAvgPrice: -56.4,
    deltaRevenue: 36.1,
    deltaMargin: -227255,
    deltaMarginPct: -14.5,
  },
  {
    id: 12,
    name: "MERCADAO",
    share: 1.76,
    rankingChange: 6,
    deltaVolume: 37.3,
    deltaAvgPrice: 2.5,
    deltaRevenue: 40.8,
    deltaMargin: 93595,
    deltaMarginPct: -1.3,
  },
  {
    id: 13,
    name: "ROSSI",
    share: 1.38,
    rankingChange: 5,
    deltaVolume: 42.4,
    deltaAvgPrice: -3.8,
    deltaRevenue: 37.0,
    deltaMargin: 197106,
    deltaMarginPct: 2.2,
  },
  {
    id: 14,
    name: "ATACADAO RS",
    share: 1.34,
    rankingChange: 2,
    deltaVolume: -2.3,
    deltaAvgPrice: 22.1,
    deltaRevenue: 19.3,
    deltaMargin: 42782,
    deltaMarginPct: -2.6,
  },
  {
    id: 15,
    name: "SAO VICENTE",
    share: 1.18,
    rankingChange: 1,
    deltaVolume: 3.4,
    deltaAvgPrice: 8.2,
    deltaRevenue: 11.9,
    deltaMargin: 143129,
    deltaMarginPct: 4.7,
  },
  {
    id: 16,
    name: "ESPERANCA",
    share: 1.13,
    rankingChange: -3,
    deltaVolume: -8.5,
    deltaAvgPrice: -0.8,
    deltaRevenue: -9.2,
    deltaMargin: -2831,
    deltaMarginPct: 1.7,
  },
  {
    id: 17,
    name: "TREMBAO/BOX 34",
    share: 1.11,
    rankingChange: -5,
    deltaVolume: -12.9,
    deltaAvgPrice: -3.7,
    deltaRevenue: -16.2,
    deltaMargin: -452525,
    deltaMarginPct: -11.9,
  },
  {
    id: 18,
    name: "COMERCIAL SOUZA",
    share: 1.09,
    rankingChange: 3,
    deltaVolume: 21.5,
    deltaAvgPrice: 1.3,
    deltaRevenue: 23.0,
    deltaMargin: 96188,
    deltaMarginPct: 1.9,
  },
  {
    id: 19,
    name: "SUPERMERCADO X",
    share: 0.97,
    rankingChange: 2,
    deltaVolume: 29.6,
    deltaAvgPrice: -7.3,
    deltaRevenue: 20.1,
    deltaMargin: -16221,
    deltaMarginPct: -2.3,
  },
  {
    id: 20,
    name: "KRILL",
    share: 0.92,
    rankingChange: 1,
    deltaVolume: -14.5,
    deltaAvgPrice: 33.3,
    deltaRevenue: 14.0,
    deltaMargin: 12500,
    deltaMarginPct: -1.2,
  },
  {
    id: 21,
    name: "ATACADAO RJ",
    share: 0.9,
    rankingChange: -8,
    deltaVolume: -31.7,
    deltaAvgPrice: 10.7,
    deltaRevenue: -24.4,
    deltaMargin: -217010,
    deltaMarginPct: -4.1,
  },
  {
    id: 22,
    name: "MART MINAS",
    share: 0.76,
    rankingChange: -10,
    deltaVolume: -48.4,
    deltaAvgPrice: 30.5,
    deltaRevenue: -32.7,
    deltaMargin: -181350,
    deltaMarginPct: -0.6,
  },
  {
    id: 23,
    name: "DICON RJ",
    share: 0.68,
    rankingChange: 3,
    deltaVolume: 22.9,
    deltaAvgPrice: 3.1,
    deltaRevenue: 26.7,
    deltaMargin: 10553,
    deltaMarginPct: -7.8,
  },
  {
    id: 24,
    name: "DIA %",
    share: 0.68,
    rankingChange: 1,
    deltaVolume: -1.1,
    deltaAvgPrice: 12.2,
    deltaRevenue: 11.0,
    deltaMargin: 49178,
    deltaMarginPct: 0.5,
  },
  {
    id: 25,
    name: "FORT ATACADISTA",
    share: 0.67,
    rankingChange: 3,
    deltaVolume: 19.9,
    deltaAvgPrice: 4.5,
    deltaRevenue: 25.3,
    deltaMargin: 77562,
    deltaMarginPct: 4.0,
  },
  {
    id: 26,
    name: "ASSAI RJ",
    share: 0.67,
    rankingChange: -9,
    deltaVolume: -35.8,
    deltaAvgPrice: 7.2,
    deltaRevenue: -31.2,
    deltaMargin: -335678,
    deltaMarginPct: -7.8,
  },
  {
    id: 27,
    name: "SPANI",
    share: 0.66,
    rankingChange: 20,
    deltaVolume: 184.6,
    deltaAvgPrice: -20.1,
    deltaRevenue: 127.3,
    deltaMargin: -70669,
    deltaMarginPct: -18.5,
  },
  {
    id: 28,
    name: "1 REAL ABC BAIXADA",
    share: 0.65,
    rankingChange: 2,
    deltaVolume: 29.1,
    deltaAvgPrice: -4.3,
    deltaRevenue: 23.5,
    deltaMargin: 4174,
    deltaMarginPct: -2.7,
  },
  {
    id: 29,
    name: "CHAMA",
    share: 0.62,
    rankingChange: 0,
    deltaVolume: 1.5,
    deltaAvgPrice: 5.6,
    deltaRevenue: 7.2,
    deltaMargin: 21242,
    deltaMarginPct: 1.1,
  },
  {
    id: 30,
    name: "BARBOSA",
    share: 0.56,
    rankingChange: 0,
    deltaVolume: -0.8,
    deltaAvgPrice: 9.6,
    deltaRevenue: 8.7,
    deltaMargin: 42259,
    deltaMarginPct: 2.1,
  },
  {
    id: 31,
    name: "HIGA ATACADO",
    share: 0.55,
    rankingChange: 4,
    deltaVolume: 45.7,
    deltaAvgPrice: -8.9,
    deltaRevenue: 32.8,
    deltaMargin: 31792,
    deltaMarginPct: -1.4,
  },
  {
    id: 32,
    name: "GOOD BOM",
    share: 0.55,
    rankingChange: -3,
    deltaVolume: -8.7,
    deltaAvgPrice: 1.0,
    deltaRevenue: -7.8,
    deltaMargin: -84283,
    deltaMarginPct: -5.8,
  },
  {
    id: 33,
    name: "CARREFOUR",
    share: 0.52,
    rankingChange: 30,
    deltaVolume: 831.9,
    deltaAvgPrice: -27.0,
    deltaRevenue: 580.3,
    deltaMargin: 142047,
    deltaMarginPct: -13.2,
  },
  {
    id: 34,
    name: "MUFFATO",
    share: 0.52,
    rankingChange: -15,
    deltaVolume: -19.5,
    deltaAvgPrice: -30.9,
    deltaRevenue: -44.4,
    deltaMargin: -515164,
    deltaMarginPct: -29.1,
  },
  {
    id: 35,
    name: "ATACADAO BA",
    share: 0.51,
    rankingChange: -7,
    deltaVolume: -25.9,
    deltaAvgPrice: 4.3,
    deltaRevenue: -22.7,
    deltaMargin: -157989,
    deltaMarginPct: -6.2,
  },
  {
    id: 36,
    name: "HIGAS",
    share: 0.5,
    rankingChange: 5,
    deltaVolume: 23.6,
    deltaAvgPrice: 10.1,
    deltaRevenue: 36.2,
    deltaMargin: 111235,
    deltaMarginPct: 7.9,
  },
  {
    id: 37,
    name: "KACULA",
    share: 0.49,
    rankingChange: -1,
    deltaVolume: -0.2,
    deltaAvgPrice: -1.1,
    deltaRevenue: -1.3,
    deltaMargin: -54490,
    deltaMarginPct: -5.0,
  },
  {
    id: 38,
    name: "BOA",
    share: 0.49,
    rankingChange: 3,
    deltaVolume: 6.2,
    deltaAvgPrice: 15.4,
    deltaRevenue: 22.5,
    deltaMargin: 134406,
    deltaMarginPct: 11.6,
  },
  {
    id: 39,
    name: "AKKI",
    share: 0.48,
    rankingChange: 0,
    deltaVolume: 1.8,
    deltaAvgPrice: 0.2,
    deltaRevenue: 2.0,
    deltaMargin: 11585,
    deltaMarginPct: 0.6,
  },
  {
    id: 40,
    name: "SUPERMERCADO 3M",
    share: 0.47,
    rankingChange: 3,
    deltaVolume: 20.9,
    deltaAvgPrice: 6.1,
    deltaRevenue: 28.3,
    deltaMargin: 46633,
    deltaMarginPct: 1.7,
  },
  {
    id: 41,
    name: "LOPES",
    share: 0.46,
    rankingChange: 8,
    deltaVolume: 26.2,
    deltaAvgPrice: 17.2,
    deltaRevenue: 47.9,
    deltaMargin: 209902,
    deltaMarginPct: 17.7,
  },
  {
    id: 42,
    name: "ATACADAO MS",
    share: 0.43,
    rankingChange: -12,
    deltaVolume: -51.2,
    deltaAvgPrice: 18.1,
    deltaRevenue: -42.4,
    deltaMargin: -186631,
    deltaMarginPct: -1.3,
  },
  {
    id: 43,
    name: "REDE LITORAL",
    share: 0.43,
    rankingChange: 0,
    deltaVolume: 0.4,
    deltaAvgPrice: 7.5,
    deltaRevenue: 7.9,
    deltaMargin: 11063,
    deltaMarginPct: 0.1,
  },
  {
    id: 44,
    name: "SANTA FE",
    share: 0.4,
    rankingChange: 2,
    deltaVolume: 13.3,
    deltaAvgPrice: 3.2,
    deltaRevenue: 16.9,
    deltaMargin: 18190,
    deltaMarginPct: -0.8,
  },
  {
    id: 45,
    name: "TAUSTE",
    share: 0.4,
    rankingChange: -1,
    deltaVolume: -10.2,
    deltaAvgPrice: 7.9,
    deltaRevenue: -3.1,
    deltaMargin: -8256,
    deltaMarginPct: -0.4,
  },
  {
    id: 46,
    name: "ATACADAO PR",
    share: 0.39,
    rankingChange: -8,
    deltaVolume: -29.4,
    deltaAvgPrice: 5.0,
    deltaRevenue: -25.8,
    deltaMargin: -89582,
    deltaMarginPct: -2.8,
  },
  {
    id: 47,
    name: "NEI VAREJO",
    share: 0.39,
    rankingChange: 0,
    deltaVolume: -7.2,
    deltaAvgPrice: 10.1,
    deltaRevenue: 2.2,
    deltaMargin: 10469,
    deltaMarginPct: 0.8,
  },
  {
    id: 48,
    name: "NEGREIROS",
    share: 0.37,
    rankingChange: 0,
    deltaVolume: 1.2,
    deltaAvgPrice: 1.4,
    deltaRevenue: 2.7,
    deltaMargin: 3641,
    deltaMarginPct: 0.1,
  },
  {
    id: 49,
    name: "SR DISTRIBUIDORA",
    share: 0.36,
    rankingChange: 5,
    deltaVolume: 35.3,
    deltaAvgPrice: 2.0,
    deltaRevenue: 38.0,
    deltaMargin: 43750,
    deltaMarginPct: -0.6,
  },
  {
    id: 50,
    name: "PARANA SP",
    share: 0.36,
    rankingChange: 3,
    deltaVolume: 4.0,
    deltaAvgPrice: 19.8,
    deltaRevenue: 24.7,
    deltaMargin: 49863,
    deltaMarginPct: 3.5,
  },
  {
    id: 51,
    name: "CERCADAO",
    share: 0.36,
    rankingChange: 3,
    deltaVolume: 23.2,
    deltaAvgPrice: 2.5,
    deltaRevenue: 26.3,
    deltaMargin: 4531,
    deltaMarginPct: -2.0,
  },
  {
    id: 52,
    name: "ATACADAO DF/GO/TO",
    share: 0.33,
    rankingChange: -14,
    deltaVolume: -52.3,
    deltaAvgPrice: 16.3,
    deltaRevenue: -44.5,
    deltaMargin: -162723,
    deltaMarginPct: 0.6,
  },
  {
    id: 53,
    name: "BERGAMINI",
    share: 0.31,
    rankingChange: -2,
    deltaVolume: -15.0,
    deltaAvgPrice: 9.9,
    deltaRevenue: -6.6,
    deltaMargin: 26032,
    deltaMarginPct: 4.7,
  },
  {
    id: 54,
    name: "JOANIN",
    share: 0.3,
    rankingChange: -6,
    deltaVolume: -30.2,
    deltaAvgPrice: 15.3,
    deltaRevenue: -19.6,
    deltaMargin: -36359,
    deltaMarginPct: -0.1,
  },
  {
    id: 55,
    name: "AMAZON",
    share: 0.29,
    rankingChange: 10,
    deltaVolume: 28.4,
    deltaAvgPrice: 23.0,
    deltaRevenue: 57.9,
    deltaMargin: 79031,
    deltaMarginPct: 1.5,
  },
  {
    id: 56,
    name: "DOM ATACAREJO",
    share: 0.29,
    rankingChange: 4,
    deltaVolume: -4.5,
    deltaAvgPrice: 37.7,
    deltaRevenue: 31.5,
    deltaMargin: 25681,
    deltaMarginPct: 1.5,
  },
  {
    id: 57,
    name: "ATACADAO PE",
    share: 0.29,
    rankingChange: 7,
    deltaVolume: 45.0,
    deltaAvgPrice: 0.3,
    deltaRevenue: 45.4,
    deltaMargin: -14225,
    deltaMarginPct: -11.1,
  },
  {
    id: 58,
    name: "UNIAO",
    share: 0.28,
    rankingChange: -6,
    deltaVolume: -6.2,
    deltaAvgPrice: -16.7,
    deltaRevenue: -21.8,
    deltaMargin: -63650,
    deltaMarginPct: -4.9,
  },
  {
    id: 59,
    name: "FONTE NOVA",
    share: 0.27,
    rankingChange: -4,
    deltaVolume: -14.3,
    deltaAvgPrice: -1.0,
    deltaRevenue: -15.2,
    deltaMargin: -21229,
    deltaMarginPct: -0.9,
  },
  {
    id: 60,
    name: "TENDA",
    share: 0.27,
    rankingChange: -13,
    deltaVolume: -51.0,
    deltaAvgPrice: 17.3,
    deltaRevenue: -42.5,
    deltaMargin: -54521,
    deltaMarginPct: 3.0,
  },
  {
    id: 61,
    name: "REDE PLUS",
    share: 0.27,
    rankingChange: -2,
    deltaVolume: -19.9,
    deltaAvgPrice: 15.9,
    deltaRevenue: -7.1,
    deltaMargin: 27650,
    deltaMarginPct: 6.0,
  },
  {
    id: 62,
    name: "AYUMI",
    share: 0.25,
    rankingChange: 4,
    deltaVolume: 25.9,
    deltaAvgPrice: 3.1,
    deltaRevenue: 29.8,
    deltaMargin: 34465,
    deltaMarginPct: 5.0,
  },
  {
    id: 63,
    name: "SAVEGNAGO",
    share: 0.25,
    rankingChange: -4,
    deltaVolume: -9.3,
    deltaAvgPrice: -6.3,
    deltaRevenue: -15.0,
    deltaMargin: -70456,
    deltaMarginPct: -10.7,
  },
  {
    id: 64,
    name: "CATANDUVA",
    share: 0.25,
    rankingChange: 1,
    deltaVolume: 4.5,
    deltaAvgPrice: 8.6,
    deltaRevenue: 13.5,
    deltaMargin: -1076,
    deltaMarginPct: -1.6,
  },
  {
    id: 65,
    name: "SUMERBOL",
    share: 0.24,
    rankingChange: -1,
    deltaVolume: -9.6,
    deltaAvgPrice: 9.4,
    deltaRevenue: -1.1,
    deltaMargin: 11324,
    deltaMarginPct: 2.3,
  },
  {
    id: 66,
    name: "REDE PRIMOS",
    share: 0.24,
    rankingChange: 0,
    deltaVolume: 1.5,
    deltaAvgPrice: 6.5,
    deltaRevenue: 8.0,
    deltaMargin: 20033,
    deltaMarginPct: 2.9,
  },
  {
    id: 67,
    name: "BIG BOX - ULTRA BOX",
    share: 0.23,
    rankingChange: 5,
    deltaVolume: 74.1,
    deltaAvgPrice: -23.2,
    deltaRevenue: 33.8,
    deltaMargin: 35747,
    deltaMarginPct: -7.5,
  },
  {
    id: 68,
    name: "IMEC RS",
    share: 0.23,
    rankingChange: 0,
    deltaVolume: -33.9,
    deltaAvgPrice: 58.1,
    deltaRevenue: 4.5,
    deltaMargin: 84500,
    deltaMarginPct: 17.3,
  },
  {
    id: 69,
    name: "DELTA MAX",
    share: 0.23,
    rankingChange: 7,
    deltaVolume: 52.9,
    deltaAvgPrice: -4.2,
    deltaRevenue: 46.5,
    deltaMargin: -23788,
    deltaMarginPct: -5.3,
  },
  {
    id: 70,
    name: "COOP",
    share: 0.23,
    rankingChange: 25,
    deltaVolume: 571.1,
    deltaAvgPrice: -40.1,
    deltaRevenue: 301.6,
    deltaMargin: 77108,
    deltaMarginPct: 17.8,
  },
  {
    id: 71,
    name: "ROD RAF",
    share: 0.22,
    rankingChange: -4,
    deltaVolume: -20.1,
    deltaAvgPrice: 5.0,
    deltaRevenue: -16.1,
    deltaMargin: -11966,
    deltaMarginPct: 0.7,
  },
  {
    id: 72,
    name: "EXPORTACAO",
    share: 0.19,
    rankingChange: -10,
    deltaVolume: -49.6,
    deltaAvgPrice: 24.2,
    deltaRevenue: -37.4,
    deltaMargin: 50679,
    deltaMarginPct: 12.9,
  },
  {
    id: 73,
    name: "ROSALINA",
    share: 0.19,
    rankingChange: 0,
    deltaVolume: -1.8,
    deltaAvgPrice: 3.5,
    deltaRevenue: 1.6,
    deltaMargin: 4427,
    deltaMarginPct: 0.9,
  },
  {
    id: 74,
    name: "MAGNANIMO",
    share: 0.19,
    rankingChange: -1,
    deltaVolume: -2.6,
    deltaAvgPrice: 1.2,
    deltaRevenue: -1.4,
    deltaMargin: -8787,
    deltaMarginPct: -2.0,
  },
  {
    id: 75,
    name: "COVABRA",
    share: 0.18,
    rankingChange: 18,
    deltaVolume: 131.9,
    deltaAvgPrice: 10.4,
    deltaRevenue: 156.1,
    deltaMargin: -17544,
    deltaMarginPct: -4.3,
  },
  {
    id: 76,
    name: "EMJ",
    share: 0.18,
    rankingChange: -3,
    deltaVolume: -19.0,
    deltaAvgPrice: 10.6,
    deltaRevenue: -10.5,
    deltaMargin: 10504,
    deltaMarginPct: 4.1,
  },
  {
    id: 77,
    name: "PORTO SEGURO",
    share: 0.18,
    rankingChange: 5,
    deltaVolume: 22.7,
    deltaAvgPrice: 8.9,
    deltaRevenue: 33.6,
    deltaMargin: 31738,
    deltaMarginPct: 3.5,
  },
  {
    id: 78,
    name: "SANTO",
    share: 0.17,
    rankingChange: 2,
    deltaVolume: 10.4,
    deltaAvgPrice: 4.9,
    deltaRevenue: 15.9,
    deltaMargin: 2260,
    deltaMarginPct: -0.5,
  },
  {
    id: 79,
    name: "ATACADAO LATICINIOS",
    share: 0.17,
    rankingChange: 20,
    deltaVolume: 192.9,
    deltaAvgPrice: 2.1,
    deltaRevenue: 199.2,
    deltaMargin: 53497,
    deltaMarginPct: -8.4,
  },
  {
    id: 80,
    name: "CLUB DE CAMPO",
    share: 0.17,
    rankingChange: -3,
    deltaVolume: -19.8,
    deltaAvgPrice: 7.9,
    deltaRevenue: -13.4,
    deltaMargin: -324,
    deltaMarginPct: 2.9,
  },
  {
    id: 81,
    name: "ATACADAO CE/PI/MA",
    share: 0.16,
    rankingChange: -18,
    deltaVolume: -71.7,
    deltaAvgPrice: 32.8,
    deltaRevenue: -62.4,
    deltaMargin: -145294,
    deltaMarginPct: -4.4,
  },
  {
    id: 82,
    name: "FLAMBOYANT",
    share: 0.16,
    rankingChange: -1,
    deltaVolume: -10.3,
    deltaAvgPrice: 7.5,
    deltaRevenue: -3.6,
    deltaMargin: -3513,
    deltaMarginPct: -0.2,
  },
  {
    id: 83,
    name: "REDE SINCO",
    share: 0.16,
    rankingChange: -2,
    deltaVolume: -2.2,
    deltaAvgPrice: -7.7,
    deltaRevenue: -9.8,
    deltaMargin: 231,
    deltaMarginPct: 1.6,
  },
  {
    id: 84,
    name: "ATACADAO SC",
    share: 0.16,
    rankingChange: -12,
    deltaVolume: -43.7,
    deltaAvgPrice: 0.2,
    deltaRevenue: -43.6,
    deltaMargin: -65350,
    deltaMarginPct: -2.1,
  },
  {
    id: 85,
    name: "ATACADAO MG",
    share: 0.16,
    rankingChange: -10,
    deltaVolume: -45.0,
    deltaAvgPrice: 14.5,
    deltaRevenue: -37.0,
    deltaMargin: -80462,
    deltaMarginPct: -8.6,
  },
  {
    id: 86,
    name: "PRIMATUS",
    share: 0.16,
    rankingChange: 0,
    deltaVolume: -8.8,
    deltaAvgPrice: 16.0,
    deltaRevenue: 5.8,
    deltaMargin: -20526,
    deltaMarginPct: -6.7,
  },
  {
    id: 87,
    name: "RUCAS",
    share: 0.16,
    rankingChange: -15,
    deltaVolume: -55.8,
    deltaAvgPrice: 2.9,
    deltaRevenue: -54.5,
    deltaMargin: -176056,
    deltaMarginPct: -1.2,
  },
  {
    id: 88,
    name: "CATO",
    share: 0.15,
    rankingChange: -2,
    deltaVolume: -6.6,
    deltaAvgPrice: 0.7,
    deltaRevenue: -6.0,
    deltaMargin: -15260,
    deltaMarginPct: -3.6,
  },
  {
    id: 89,
    name: "ATACADAO ES",
    share: 0.15,
    rankingChange: -6,
    deltaVolume: -34.2,
    deltaAvgPrice: 16.8,
    deltaRevenue: -23.1,
    deltaMargin: -21841,
    deltaMarginPct: 1.5,
  },
  {
    id: 90,
    name: "ASSAI CE/PI",
    share: 0.14,
    rankingChange: -2,
    deltaVolume: 12.3,
    deltaAvgPrice: -16.3,
    deltaRevenue: -6.0,
    deltaMargin: -14652,
    deltaMarginPct: -3.3,
  },
  {
    id: 91,
    name: "KI BARATO",
    share: 0.14,
    rankingChange: 15,
    deltaVolume: 90.2,
    deltaAvgPrice: 3.1,
    deltaRevenue: 96.0,
    deltaMargin: 12903,
    deltaMarginPct: -1.5,
  },
  {
    id: 92,
    name: "ALABARCE",
    share: 0.14,
    rankingChange: 0,
    deltaVolume: -0.7,
    deltaAvgPrice: 1.4,
    deltaRevenue: 0.7,
    deltaMargin: -2755,
    deltaMarginPct: -1.0,
  },
  {
    id: 93,
    name: "ZAFFARI",
    share: 0.14,
    rankingChange: -20,
    deltaVolume: -55.3,
    deltaAvgPrice: -31.2,
    deltaRevenue: -69.2,
    deltaMargin: -188322,
    deltaMarginPct: -25.7,
  },
  {
    id: 94,
    name: "ASSAI BA",
    share: 0.14,
    rankingChange: 3,
    deltaVolume: 26.3,
    deltaAvgPrice: -4.6,
    deltaRevenue: 20.4,
    deltaMargin: 9380,
    deltaMarginPct: -0.2,
  },
  {
    id: 95,
    name: "DO VALE",
    share: 0.14,
    rankingChange: 1,
    deltaVolume: 7.3,
    deltaAvgPrice: 2.3,
    deltaRevenue: 9.7,
    deltaMargin: 13969,
    deltaMarginPct: 3.9,
  },
  {
    id: 96,
    name: "PONTO CERTO",
    share: 0.13,
    rankingChange: 2,
    deltaVolume: 8.6,
    deltaAvgPrice: 8.6,
    deltaRevenue: 18.0,
    deltaMargin: 14924,
    deltaMarginPct: 2.2,
  },
  {
    id: 97,
    name: "CIA ZAFFARI",
    share: 0.13,
    rankingChange: 7,
    deltaVolume: 21.4,
    deltaAvgPrice: 18.0,
    deltaRevenue: 43.3,
    deltaMargin: 27267,
    deltaMarginPct: 0.8,
  },
  {
    id: 98,
    name: "GASPAR",
    share: 0.13,
    rankingChange: -3,
    deltaVolume: -12.0,
    deltaAvgPrice: 2.0,
    deltaRevenue: -10.2,
    deltaMargin: -7321,
    deltaMarginPct: -0.9,
  },
  {
    id: 99,
    name: "ATENDE NSA / SUPRALINE",
    share: 0.12,
    rankingChange: -4,
    deltaVolume: -18.2,
    deltaAvgPrice: 1.0,
    deltaRevenue: -17.4,
    deltaMargin: -17706,
    deltaMarginPct: -1.3,
  },
  {
    id: 100,
    name: "ANDORINHA",
    share: 0.12,
    rankingChange: -9,
    deltaVolume: -52.0,
    deltaAvgPrice: 34.3,
    deltaRevenue: -35.5,
    deltaMargin: -6472,
    deltaMarginPct: 5.4,
  },
];

// Mock data for client cascade tree (P&L profitability breakdown)
// Real data from Food Brands BigQuery table
// Structure:
// Level 1: Total Company (root)
// Level 2: Gross Margin + / Gross Margin - (from root)
// Level 3: Serve Margin + / Serve Margin - (from Gross Margin +)
// Level 4: EBITDA + / EBITDA - (from Serve Margin +, optional - n/a for Food Brands)
export const mockClientCascadeData = {
  // Level 1: Total Company
  root: {
    title: "Total",
    clients: 3904,
    revenue: 570663751, // 570.7M
    margin: 109293108, // 109.3M serve margin
  },
  // Level 2: Gross Margin split (from root)
  grossMargin: {
    positive: {
      title: "Mg B positiva",
      clients: 3867,
      revenue: 571628768,
      margin: 110895604,
    },
    negative: {
      title: "Mg B negativa",
      clients: 37,
      revenue: -965017, // Negative revenue (returns/cancellations)
      margin: -1602496,
    },
  },
  // Level 3: Serve Margin split (from Gross Margin +)
  serveMargin: {
    positive: {
      title: "Mg S positiva",
      clients: 3789,
      revenue: 564855965,
      margin: 111422834,
    },
    negative: {
      title: "Mg S negativa",
      clients: 78,
      revenue: 6772803,
      margin: -527230,
    },
  },
  // Level 4: EBITDA split (from Serve Margin +, optional)
  // n/a for Food Brands - P&L doesn't go to EBITDA level
  ebitda: null,
};

// Company-wide mix data (for comparison in donut charts) - Real data from BigQuery
// Used for Top Clients section (Categories and Brands)
export const companyMixData = {
  categories: [
    { name: "Molhos", value: 18.9 },
    { name: "Farináceos", value: 18.0 },
    { name: "Especiarias", value: 15.1 },
    { name: "Pipoca", value: 9.8 },
    { name: "Farofa", value: 8.3 },
    { name: "Cond. Industrializados", value: 6.3 },
    { name: "Batata Palha", value: 5.2 },
    { name: "Outros", value: 5.0 },
    { name: "Grãos", value: 3.8 },
    { name: "Maionese", value: 3.4 },
    { name: "Sopas e Cremes", value: 2.7 },
    { name: "Cereais Matinais", value: 2.3 },
  ],
  brands: [
    { name: "Kisabor", value: 77.6 },
    { name: "Billy & Jack", value: 11.2 },
    { name: "Natus", value: 2.0 },
    { name: "D Cheff", value: 1.8 },
    { name: "Qualita", value: 1.4 },
    { name: "Public", value: 0.9 },
    { name: "Aroma das Índias", value: 0.8 },
    { name: "Tempera Fácil", value: 0.8 },
    { name: "Outros", value: 3.5 },
  ],
};

// Mock client mix data (would come from API based on selected client)
// Client 1 (ASSAI SP / SENDAS) uses real BigQuery data
export const getClientMixData = (clientId) => {
  // Simulated different mixes per client
  const clientMixes = {
    1: {
      // ASSAI SP (SENDAS) - Real data from BigQuery
      categories: [
        { name: "Farináceos", value: 26.7 },
        { name: "Especiarias", value: 20.0 },
        { name: "Pipoca", value: 16.7 },
        { name: "Molhos", value: 15.8 },
        { name: "Farofa", value: 6.6 },
        { name: "Cond. Industrializados", value: 4.4 },
        { name: "Outros", value: 4.0 },
        { name: "Sopas e Cremes", value: 1.7 },
        { name: "Maionese", value: 1.7 },
        { name: "Cereais Matinais", value: 1.5 },
        { name: "Granolas", value: 1.3 },
      ],
      brands: [
        { name: "Kisabor", value: 83.9 },
        { name: "Billy & Jack", value: 10.8 },
        { name: "Natus", value: 3.2 },
        { name: "Tempera Fácil", value: 1.9 },
        { name: "Brhama", value: 0.4 },
      ],
    },
    2: {
      // ATACADAO SP - Simulated variation
      categories: [
        { name: "Molhos", value: 22.5 },
        { name: "Farináceos", value: 19.2 },
        { name: "Especiarias", value: 16.8 },
        { name: "Pipoca", value: 12.1 },
        { name: "Farofa", value: 9.5 },
        { name: "Cond. Industrializados", value: 7.2 },
        { name: "Batata Palha", value: 5.8 },
        { name: "Outros", value: 6.9 },
      ],
      brands: [
        { name: "Kisabor", value: 72.4 },
        { name: "Billy & Jack", value: 14.5 },
        { name: "Natus", value: 4.2 },
        { name: "D Cheff", value: 3.8 },
        { name: "Qualita", value: 2.1 },
        { name: "Outros", value: 3.0 },
      ],
    },
    3: {
      // VAREJO - Simulated variation
      categories: [
        { name: "Especiarias", value: 21.3 },
        { name: "Molhos", value: 18.9 },
        { name: "Farináceos", value: 16.4 },
        { name: "Pipoca", value: 11.2 },
        { name: "Batata Palha", value: 8.7 },
        { name: "Farofa", value: 7.8 },
        { name: "Cond. Industrializados", value: 6.5 },
        { name: "Outros", value: 9.2 },
      ],
      brands: [
        { name: "Kisabor", value: 68.5 },
        { name: "Billy & Jack", value: 12.8 },
        { name: "D Cheff", value: 5.2 },
        { name: "Natus", value: 3.5 },
        { name: "Aroma das Índias", value: 2.8 },
        { name: "Outros", value: 7.2 },
      ],
    },
  };

  // Default mix for other clients (slight variation from company average)
  const defaultMix = {
    categories: [
      { name: "Biscoitos", value: 26.5 + Math.random() * 6 },
      { name: "Massas", value: 20.3 + Math.random() * 5 },
      { name: "Farinhas", value: 16.7 + Math.random() * 4 },
      { name: "Snacks", value: 11.4 + Math.random() * 3 },
      { name: "Cereais", value: 8.8 + Math.random() * 3 },
      { name: "Outros", value: 7.3 + Math.random() * 2 },
    ],
    brands: [
      { name: "Marca Principal", value: 33.2 + Math.random() * 8 },
      { name: "Marca Premium", value: 22.8 + Math.random() * 6 },
      { name: "Marca Econômica", value: 17.5 + Math.random() * 5 },
      { name: "Marca Regional", value: 11.3 + Math.random() * 4 },
      { name: "Terceiros", value: 8.2 + Math.random() * 3 },
    ],
  };

  return clientMixes[clientId] || defaultMix;
};

// =============================================================================
// TOP PRODUCTS DATA (Channels and Regions mix)
// =============================================================================

// Real data from BigQuery - Food Brands YTD 2025 (channels and regions)
export const companyMixDataProducts = {
  channels: [
    { name: "Atacado Cash & Carry", value: 36.2 },
    { name: "Supermercado 5-10 CK", value: 15.1 },
    { name: "Supermercado 11-30 CK", value: 13.3 },
    { name: "Atacado Tradicional", value: 8.8 },
    { name: "CD", value: 7.5 },
    { name: "Distribuidor", value: 6.2 },
    { name: "Outros", value: 12.9 },
  ],
  regions: [
    { name: "Sudeste", value: 90.2 },
    { name: "Sul", value: 5.5 },
    { name: "Nordeste", value: 2.2 },
    { name: "Centro-Oeste", value: 1.9 },
    { name: "Norte", value: 0.2 },
  ],
};

// Real data from BigQuery - Product-specific mix (Channels and Regions)
export const getProductMixData = (productId) => {
  const productMixes = {
    1: {
      // FLOCAO 12X500GRS - Real data from BigQuery
      channels: [
        { name: "Atacado Cash & Carry", value: 48.7 },
        { name: "Supermercado 11-30 CK", value: 18.8 },
        { name: "Supermercado 5-10 CK", value: 9.8 },
        { name: "CD", value: 8.9 },
        { name: "Atacado Tradicional", value: 5.5 },
        { name: "Outros", value: 8.3 },
      ],
      regions: [
        { name: "Sudeste", value: 99.3 },
        { name: "Sul", value: 0.4 },
        { name: "Centro-Oeste", value: 0.3 },
      ],
    },
    2: {
      // FAROFA PRONTA 24X400GRS - Real data from BigQuery
      channels: [
        { name: "Atacado Cash & Carry", value: 44.6 },
        { name: "Supermercado 11-30 CK", value: 16.2 },
        { name: "Supermercado 5-10 CK", value: 15.0 },
        { name: "Atacado Tradicional", value: 9.5 },
        { name: "CD", value: 5.5 },
        { name: "Outros", value: 9.2 },
      ],
      regions: [
        { name: "Sudeste", value: 89.6 },
        { name: "Sul", value: 4.4 },
        { name: "Nordeste", value: 4.3 },
        { name: "Centro-Oeste", value: 1.6 },
        { name: "Norte", value: 0.1 },
      ],
    },
    3: {
      // MOLHO ORIG BILLY JACK 6X1,01KG - Real data from BigQuery
      channels: [
        { name: "Atacado Cash & Carry", value: 48.0 },
        { name: "Distribuidor", value: 24.9 },
        { name: "Supermercado 5-10 CK", value: 8.6 },
        { name: "Atacado Tradicional", value: 7.1 },
        { name: "Outros", value: 11.4 },
      ],
      regions: [
        { name: "Sudeste", value: 93.9 },
        { name: "Sul", value: 3.6 },
        { name: "Nordeste", value: 2.1 },
        { name: "Centro-Oeste", value: 0.4 },
      ],
    },
  };

  // Default mix for other products (based on company average with slight variation)
  const defaultMix = {
    channels: [
      { name: "Atacado Cash & Carry", value: 36.0 + Math.random() * 15 },
      { name: "Supermercado 5-10 CK", value: 12.0 + Math.random() * 8 },
      { name: "Supermercado 11-30 CK", value: 10.0 + Math.random() * 8 },
      { name: "Atacado Tradicional", value: 6.0 + Math.random() * 6 },
      { name: "CD", value: 5.0 + Math.random() * 5 },
      { name: "Distribuidor", value: 4.0 + Math.random() * 5 },
      { name: "Outros", value: 8.0 + Math.random() * 5 },
    ],
    regions: [
      { name: "Sudeste", value: 85.0 + Math.random() * 10 },
      { name: "Sul", value: 3.0 + Math.random() * 5 },
      { name: "Nordeste", value: 1.0 + Math.random() * 4 },
      { name: "Centro-Oeste", value: 1.0 + Math.random() * 3 },
      { name: "Norte", value: 0.1 + Math.random() * 0.5 },
    ],
  };

  return productMixes[productId] || defaultMix;
};

// Real data from BigQuery - Food Brands YTD 2025 vs YTD 2024
export const mockTopProducts = [
  {
    id: 1,
    name: "FLOCAO 12X500GRS",
    share: 6.96,
    deltaVolume: -19.2,
    deltaAvgPrice: 6.2,
    deltaRevenue: -14.2,
    deltaMargin: -189248,
    deltaMarginPct: 1.3,
    rankingChange: 1,
  },
  {
    id: 2,
    name: "FAROFA PRONTA 24X400GRS",
    share: 5.32,
    deltaVolume: -40.0,
    deltaAvgPrice: 2.1,
    deltaRevenue: -38.7,
    deltaMargin: -581239,
    deltaMarginPct: -0.1,
    rankingChange: -1,
  },
  {
    id: 3,
    name: "MOLHO ORIG BILLY JACK 6X1,01KG",
    share: 3.63,
    deltaVolume: -36.8,
    deltaAvgPrice: 0.5,
    deltaRevenue: -36.4,
    deltaMargin: -2216532,
    deltaMarginPct: -6.7,
    rankingChange: 0,
  },
  {
    id: 4,
    name: "MILHO PIPOCA 24X400GRS",
    share: 3.5,
    deltaVolume: 30.0,
    deltaAvgPrice: -14.0,
    deltaRevenue: 11.7,
    deltaMargin: 594654,
    deltaMarginPct: 7.2,
    rankingChange: 1,
  },
  {
    id: 5,
    name: "BATATA PALHA TRADICIONAL KISABOR 20X100GR",
    share: 2.43,
    deltaVolume: -32.6,
    deltaAvgPrice: -0.2,
    deltaRevenue: -32.8,
    deltaMargin: -144418,
    deltaMarginPct: -4.0,
    rankingChange: -1,
  },
  {
    id: 6,
    name: "MILHO DE PIPOCA PREMIUM 24X400GRS",
    share: 2.25,
    deltaVolume: 19.4,
    deltaAvgPrice: -0.6,
    deltaRevenue: 18.6,
    deltaMargin: 848036,
    deltaMarginPct: 15.7,
    rankingChange: 3,
  },
  {
    id: 7,
    name: "BICARBONATO DE SODIO 12X500G",
    share: 1.95,
    deltaVolume: -31.1,
    deltaAvgPrice: 4.3,
    deltaRevenue: -28.1,
    deltaMargin: -462359,
    deltaMarginPct: 2.8,
    rankingChange: 0,
  },
  {
    id: 8,
    name: "MOLHO ORIG BILLY JACK 12X200G",
    share: 1.76,
    deltaVolume: -43.8,
    deltaAvgPrice: 10.3,
    deltaRevenue: -38.0,
    deltaMargin: -844600,
    deltaMarginPct: -3.9,
    rankingChange: -2,
  },
  {
    id: 9,
    name: "BATATA PALHA EXTRA FINA KISABOR 20X100GR",
    share: 1.46,
    deltaVolume: -46.0,
    deltaAvgPrice: 3.2,
    deltaRevenue: -44.3,
    deltaMargin: -155984,
    deltaMarginPct: -2.1,
    rankingChange: -1,
  },
  {
    id: 10,
    name: "CANJICA BRANCA 24X400GRS",
    share: 1.44,
    deltaVolume: 16.1,
    deltaAvgPrice: -2.6,
    deltaRevenue: 13.1,
    deltaMargin: 124127,
    deltaMarginPct: 5.0,
    rankingChange: 7,
  },
  {
    id: 11,
    name: "PIPOCA MICROONDAS MANTEIGA 36X100GRS",
    share: 1.3,
    deltaVolume: -15.0,
    deltaAvgPrice: -2.8,
    deltaRevenue: -17.3,
    deltaMargin: -57492,
    deltaMarginPct: 0.1,
    rankingChange: 0,
  },
  {
    id: 12,
    name: "FARINHA DE MILHO AMARELA 12X500GRS",
    share: 1.13,
    deltaVolume: -14.0,
    deltaAvgPrice: 2.7,
    deltaRevenue: -11.7,
    deltaMargin: -177957,
    deltaMarginPct: -2.6,
    rankingChange: 6,
  },
  {
    id: 13,
    name: "MOLHO TASTY BILLY JACK 12X200G",
    share: 1.1,
    deltaVolume: -7.2,
    deltaAvgPrice: 5.6,
    deltaRevenue: -2.0,
    deltaMargin: -102363,
    deltaMarginPct: -3.8,
    rankingChange: 9,
  },
  {
    id: 14,
    name: "TAPIOCA HIDRATADA 20X500G",
    share: 1.06,
    deltaVolume: -31.8,
    deltaAvgPrice: -5.1,
    deltaRevenue: -35.3,
    deltaMargin: -34022,
    deltaMarginPct: -2.6,
    rankingChange: -4,
  },
  {
    id: 15,
    name: "MOLHO CHEDDAR BILLY JACK 12X200G",
    share: 0.98,
    deltaVolume: -39.6,
    deltaAvgPrice: 6.7,
    deltaRevenue: -35.6,
    deltaMargin: -403360,
    deltaMarginPct: -4.8,
    rankingChange: -3,
  },
];

// Pre-aggregated Pareto chart data from backend
// This represents ALL clients in the company (not just top 100)
// Data comes pre-processed to avoid sending full client list to frontend
// Format: buckets of 2% each with cumulative data and ABCD classification
// Groups: A (0-20%), B (20-50%), C (50-80%), D (80-100%) of cumulative sales
// NOTE: Data calculated from REAL BigQuery Food Brands data (2024)
// Key insight: 1 client (SENDAS) = 15% of revenue alone!
export const mockParetoChartData = {
  // Total number of elements (clients) with positive revenue in 2024
  totalElements: 3481,
  // Summary of ABCD classification based on REAL data
  // Note: Due to extreme concentration, Group A has only 1 client
  summary: {
    groupA: {
      elements: 1, // SENDAS alone
      percentage: 0.03, // 1 / 3481
      cumulativeShare: 15.2, // First client alone = 15.2% of total revenue
      avgRevenuePerClient: 55212161, // R$ 55.2M
      avgServingMargin: 24.6, // Real data
      deltaVolume: 5.3, // Mock delta
      deltaAvgPrice: 2.1,
      deltaRevenue: 7.5,
      deltaMargin: 245000,
      deltaMarginPct: 1.8,
    },
    groupB: {
      elements: 17,
      percentage: 0.49, // 17 / 3481
      cumulativeShare: 34.8, // From 15.2% to 50%
      avgRevenuePerClient: 7409214, // R$ 7.4M per client
      avgServingMargin: 21.7, // Real data
      deltaVolume: 3.2,
      deltaAvgPrice: 1.4,
      deltaRevenue: 4.6,
      deltaMargin: 189000,
      deltaMarginPct: 0.9,
    },
    groupC: {
      elements: 197,
      percentage: 5.66, // 197 / 3481
      cumulativeShare: 30.0, // From 50% to 80%
      avgRevenuePerClient: 551697, // R$ 551K per client
      avgServingMargin: 19.3, // Real data
      deltaVolume: -1.2,
      deltaAvgPrice: 0.8,
      deltaRevenue: -0.4,
      deltaMargin: -42000,
      deltaMarginPct: -0.5,
    },
    groupD: {
      elements: 3266,
      percentage: 93.82, // 3266 / 3481
      cumulativeShare: 20.0, // Last 20% of revenue from 93.8% of clients
      avgRevenuePerClient: 22249, // R$ 22.2K per client
      avgServingMargin: 20.8, // Real data - higher margin! (list prices)
      deltaVolume: -4.8,
      deltaAvgPrice: -1.2,
      deltaRevenue: -5.9,
      deltaMargin: -156000,
      deltaMarginPct: -2.1,
    },
  },
  // Pre-calculated buckets for the chart (based on REAL Food Brands BigQuery data - 2024)
  // 3494 total clients, each bucket = 2% (~70 clients)
  // Data shows extreme concentration: top 2% = 67.5% of revenue
  // avgServingMargin from real data (increases for smaller clients - they pay list price)
  // groupsPresent: array of groups with clients in this bucket (A most relevant)
  // primaryGroup: most relevant group for coloring (A > B > C > D)
  buckets: [
    {
      bucketLabel: "0-2%",
      share: 67.5,
      cumulative: 67.5,
      group: "C",
      primaryGroup: "A",
      groupsPresent: ["A", "B", "C"],
      avgServingMargin: 21.8,
    },
    {
      bucketLabel: "2-4%",
      share: 8.0,
      cumulative: 75.5,
      group: "C",
      primaryGroup: "B",
      groupsPresent: ["B", "C"],
      avgServingMargin: 19.6,
    },
    {
      bucketLabel: "4-6%",
      share: 4.2,
      cumulative: 79.7,
      group: "C",
      primaryGroup: "C",
      groupsPresent: ["C"],
      avgServingMargin: 18.0,
    },
    {
      bucketLabel: "6-8%",
      share: 2.9,
      cumulative: 82.6,
      group: "D",
      primaryGroup: "C",
      groupsPresent: ["C", "D"],
      avgServingMargin: 20.1,
    },
    {
      bucketLabel: "8-10%",
      share: 2.2,
      cumulative: 84.9,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 19.3,
    },
    {
      bucketLabel: "10-12%",
      share: 1.7,
      cumulative: 86.6,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 19.8,
    },
    {
      bucketLabel: "12-14%",
      share: 1.4,
      cumulative: 88.0,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 20.3,
    },
    {
      bucketLabel: "14-16%",
      share: 1.2,
      cumulative: 89.2,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 18.4,
    },
    {
      bucketLabel: "16-18%",
      share: 1.0,
      cumulative: 90.2,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 21.9,
    },
    {
      bucketLabel: "18-20%",
      share: 0.9,
      cumulative: 91.1,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 19.2,
    },
    {
      bucketLabel: "20-22%",
      share: 0.8,
      cumulative: 91.9,
      group: "D",
      avgServingMargin: 18.6,
    },
    {
      bucketLabel: "22-24%",
      share: 0.7,
      cumulative: 92.6,
      group: "D",
      avgServingMargin: 20.2,
    },
    {
      bucketLabel: "24-26%",
      share: 0.6,
      cumulative: 93.2,
      group: "D",
      avgServingMargin: 22.9,
    },
    {
      bucketLabel: "26-28%",
      share: 0.6,
      cumulative: 93.8,
      group: "D",
      avgServingMargin: 21.0,
    },
    {
      bucketLabel: "28-30%",
      share: 0.5,
      cumulative: 94.3,
      group: "D",
      avgServingMargin: 19.5,
    },
    {
      bucketLabel: "30-32%",
      share: 0.5,
      cumulative: 94.8,
      group: "D",
      avgServingMargin: 23.0,
    },
    {
      bucketLabel: "32-34%",
      share: 0.4,
      cumulative: 95.2,
      group: "D",
      avgServingMargin: 22.7,
    },
    {
      bucketLabel: "34-36%",
      share: 0.4,
      cumulative: 95.6,
      group: "D",
      avgServingMargin: 20.8,
    },
    {
      bucketLabel: "36-38%",
      share: 0.4,
      cumulative: 96.0,
      group: "D",
      avgServingMargin: 23.5,
    },
    {
      bucketLabel: "38-40%",
      share: 0.3,
      cumulative: 96.3,
      group: "D",
      avgServingMargin: 22.1,
    },
    {
      bucketLabel: "40-42%",
      share: 0.3,
      cumulative: 96.6,
      group: "D",
      avgServingMargin: 21.3,
    },
    {
      bucketLabel: "42-44%",
      share: 0.3,
      cumulative: 96.9,
      group: "D",
      avgServingMargin: 23.1,
    },
    {
      bucketLabel: "44-46%",
      share: 0.2,
      cumulative: 97.1,
      group: "D",
      avgServingMargin: 20.5,
    },
    {
      bucketLabel: "46-48%",
      share: 0.2,
      cumulative: 97.3,
      group: "D",
      avgServingMargin: 21.2,
    },
    {
      bucketLabel: "48-50%",
      share: 0.2,
      cumulative: 97.5,
      group: "D",
      avgServingMargin: 24.6,
    },
    {
      bucketLabel: "50-52%",
      share: 0.2,
      cumulative: 97.7,
      group: "D",
      avgServingMargin: 23.1,
    },
    {
      bucketLabel: "52-54%",
      share: 0.2,
      cumulative: 97.9,
      group: "D",
      avgServingMargin: 22.1,
    },
    {
      bucketLabel: "54-56%",
      share: 0.2,
      cumulative: 98.1,
      group: "D",
      avgServingMargin: 23.6,
    },
    {
      bucketLabel: "56-58%",
      share: 0.2,
      cumulative: 98.3,
      group: "D",
      avgServingMargin: 24.3,
    },
    {
      bucketLabel: "58-60%",
      share: 0.15,
      cumulative: 98.45,
      group: "D",
      avgServingMargin: 23.9,
    },
    {
      bucketLabel: "60-62%",
      share: 0.14,
      cumulative: 98.59,
      group: "D",
      avgServingMargin: 22.9,
    },
    {
      bucketLabel: "62-64%",
      share: 0.13,
      cumulative: 98.72,
      group: "D",
      avgServingMargin: 23.9,
    },
    {
      bucketLabel: "64-66%",
      share: 0.12,
      cumulative: 98.84,
      group: "D",
      avgServingMargin: 23.6,
    },
    {
      bucketLabel: "66-68%",
      share: 0.1,
      cumulative: 98.94,
      group: "D",
      avgServingMargin: 26.3,
    },
    {
      bucketLabel: "68-70%",
      share: 0.09,
      cumulative: 99.03,
      group: "D",
      avgServingMargin: 21.9,
    },
    {
      bucketLabel: "70-72%",
      share: 0.08,
      cumulative: 99.11,
      group: "D",
      avgServingMargin: 25.0,
    },
    {
      bucketLabel: "72-74%",
      share: 0.07,
      cumulative: 99.18,
      group: "D",
      avgServingMargin: 23.5,
    },
    {
      bucketLabel: "74-76%",
      share: 0.06,
      cumulative: 99.24,
      group: "D",
      avgServingMargin: 25.2,
    },
    {
      bucketLabel: "76-78%",
      share: 0.05,
      cumulative: 99.29,
      group: "D",
      avgServingMargin: 26.1,
    },
    {
      bucketLabel: "78-80%",
      share: 0.05,
      cumulative: 99.34,
      group: "D",
      avgServingMargin: 22.6,
    },
    {
      bucketLabel: "80-82%",
      share: 0.04,
      cumulative: 99.38,
      group: "D",
      avgServingMargin: 26.5,
    },
    {
      bucketLabel: "82-84%",
      share: 0.04,
      cumulative: 99.42,
      group: "D",
      avgServingMargin: 27.6,
    },
    {
      bucketLabel: "84-86%",
      share: 0.03,
      cumulative: 99.45,
      group: "D",
      avgServingMargin: 27.3,
    },
    {
      bucketLabel: "86-88%",
      share: 0.03,
      cumulative: 99.48,
      group: "D",
      avgServingMargin: 26.2,
    },
    {
      bucketLabel: "88-90%",
      share: 0.02,
      cumulative: 99.5,
      group: "D",
      avgServingMargin: 26.4,
    },
    {
      bucketLabel: "90-92%",
      share: 0.02,
      cumulative: 99.52,
      group: "D",
      avgServingMargin: 27.4,
    },
    {
      bucketLabel: "92-94%",
      share: 0.01,
      cumulative: 99.53,
      group: "D",
      avgServingMargin: 26.9,
    },
    {
      bucketLabel: "94-96%",
      share: 0.01,
      cumulative: 99.54,
      group: "D",
      avgServingMargin: 30.4,
    },
    // Last buckets aggregated as they have < 0.01% each
    {
      bucketLabel: "96-100%",
      share: 0.46,
      cumulative: 100.0,
      group: "D",
      avgServingMargin: 28.0,
    },
  ],
};

// =============================================================================
// TOP PRODUCTS - PARETO CHART DATA (Real BigQuery data - 2024)
// =============================================================================
// Pre-aggregated Pareto chart data for products
// 945 products with positive revenue in 2024
// Groups: A (0-20%), B (20-50%), C (50-80%), D (80-100%) of cumulative sales
export const mockParetoChartDataProducts = {
  totalElements: 945,
  summary: {
    groupA: {
      elements: 4,
      percentage: 0.42,
      cumulativeShare: 19.1,
      avgRevenuePerClient: 17280610,
      avgServingMargin: 16.2,
      deltaVolume: 0.0,
      deltaAvgPrice: -5.0,
      deltaRevenue: -5.0,
      deltaMargin: -2218918,
      deltaMarginPct: -4.6,
    },
    groupB: {
      elements: 29,
      percentage: 3.07,
      cumulativeShare: 30.5,
      avgRevenuePerClient: 3807104,
      avgServingMargin: 19.7,
      deltaVolume: 3.2,
      deltaAvgPrice: -6.6,
      deltaRevenue: -3.6,
      deltaMargin: -1272171,
      deltaMarginPct: -1.2,
    },
    groupC: {
      elements: 83,
      percentage: 8.78,
      cumulativeShare: 30.4,
      avgRevenuePerClient: 1329901,
      avgServingMargin: 24.8,
      deltaVolume: 0.0,
      deltaAvgPrice: 0.2,
      deltaRevenue: 0.2,
      deltaMargin: -1687893,
      deltaMarginPct: -2.6,
    },
    groupD: {
      elements: 829,
      percentage: 87.73,
      cumulativeShare: 20.0,
      avgRevenuePerClient: 87584,
      avgServingMargin: 29.4,
      deltaVolume: 7.8,
      deltaAvgPrice: 4.4,
      deltaRevenue: 12.5,
      deltaMargin: -241361,
      deltaMarginPct: -3.1,
    },
  },
  buckets: [
    {
      bucketLabel: "0-2%",
      share: 39.3,
      cumulative: 39.3,
      group: "B",
      primaryGroup: "A",
      groupsPresent: ["A", "B"],
      avgServingMargin: 19.6,
    },
    {
      bucketLabel: "2-4%",
      share: 13.3,
      cumulative: 52.6,
      group: "C",
      primaryGroup: "B",
      groupsPresent: ["B", "C"],
      avgServingMargin: 19.9,
    },
    {
      bucketLabel: "4-6%",
      share: 9.4,
      cumulative: 62.0,
      group: "C",
      primaryGroup: "C",
      groupsPresent: ["C"],
      avgServingMargin: 28.1,
    },
    {
      bucketLabel: "6-8%",
      share: 7.3,
      cumulative: 69.3,
      group: "C",
      primaryGroup: "C",
      groupsPresent: ["C"],
      avgServingMargin: 25.6,
    },
    {
      bucketLabel: "8-10%",
      share: 5.8,
      cumulative: 75.1,
      group: "C",
      primaryGroup: "C",
      groupsPresent: ["C"],
      avgServingMargin: 27.6,
    },
    {
      bucketLabel: "10-12%",
      share: 4.5,
      cumulative: 79.6,
      group: "C",
      primaryGroup: "C",
      groupsPresent: ["C"],
      avgServingMargin: 19.2,
    },
    {
      bucketLabel: "12-14%",
      share: 3.6,
      cumulative: 83.2,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["C", "D"],
      avgServingMargin: 18.4,
    },
    {
      bucketLabel: "14-16%",
      share: 2.9,
      cumulative: 86.1,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 22.0,
    },
    {
      bucketLabel: "16-18%",
      share: 2.3,
      cumulative: 88.4,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 16.2,
    },
    {
      bucketLabel: "18-20%",
      share: 1.7,
      cumulative: 90.1,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 20.0,
    },
    {
      bucketLabel: "20-22%",
      share: 1.5,
      cumulative: 91.6,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 26.1,
    },
    {
      bucketLabel: "22-24%",
      share: 1.3,
      cumulative: 92.9,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 28.8,
    },
    {
      bucketLabel: "24-26%",
      share: 1.0,
      cumulative: 93.9,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 19.3,
    },
    {
      bucketLabel: "26-28%",
      share: 0.9,
      cumulative: 94.8,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 16.2,
    },
    {
      bucketLabel: "28-30%",
      share: 0.8,
      cumulative: 95.6,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 33.6,
    },
    {
      bucketLabel: "30-32%",
      share: 0.7,
      cumulative: 96.3,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 25.9,
    },
    {
      bucketLabel: "32-34%",
      share: 0.6,
      cumulative: 96.9,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 19.8,
    },
    {
      bucketLabel: "34-36%",
      share: 0.5,
      cumulative: 97.4,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 23.9,
    },
    {
      bucketLabel: "36-38%",
      share: 0.4,
      cumulative: 97.8,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 29.8,
    },
    {
      bucketLabel: "38-40%",
      share: 0.3,
      cumulative: 98.1,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 24.1,
    },
    {
      bucketLabel: "40-42%",
      share: 0.3,
      cumulative: 98.4,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 29.9,
    },
    {
      bucketLabel: "42-44%",
      share: 0.3,
      cumulative: 98.7,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 31.5,
    },
    {
      bucketLabel: "44-46%",
      share: 0.2,
      cumulative: 98.9,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 31.4,
    },
    {
      bucketLabel: "46-48%",
      share: 0.2,
      cumulative: 99.1,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 33.9,
    },
    {
      bucketLabel: "48-50%",
      share: 0.2,
      cumulative: 99.3,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 29.6,
    },
    {
      bucketLabel: "50-100%",
      share: 0.7,
      cumulative: 100.0,
      group: "D",
      primaryGroup: "D",
      groupsPresent: ["D"],
      avgServingMargin: 28.5,
    },
  ],
};

// =============================================================================
// TOP PRODUCTS - CASCADE DATA (Real BigQuery data - 2024)
// =============================================================================
// Profitability cascade for products
// Shows breakdown: Total -> Gross Margin +/- -> Serve Margin +/-
export const mockProductCascadeData = {
  root: {
    title: "Total",
    clients: 962, // products
    revenue: 353504104,
    margin: 67392638,
  },
  grossMargin: {
    positive: {
      title: "Mg B positiva",
      clients: 929, // products with positive gross margin
      revenue: 352724314,
      margin: 67690476,
    },
    negative: {
      title: "Mg B negativa",
      clients: 33, // products with negative gross margin
      revenue: 779790,
      margin: -297838,
    },
  },
  serveMargin: {
    positive: {
      title: "Mg S positiva",
      clients: 877, // products with positive serve margin
      revenue: 312431313,
      margin: 70054915,
    },
    negative: {
      title: "Mg S negativa",
      clients: 52, // products with negative serve margin
      revenue: 40293001,
      margin: -2364439,
    },
  },
  ebitda: null, // Not available for Food Brands
};
